// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"b24ec572","684":"0ebffc82","724":"dc6329f0"}[chunkId] + ".chunk.css";
};